import type { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'
import { cx } from 'cva'
import type { ComponentProps, FC } from 'react'
import type { NavState } from '../organisms/NavOverlay'
import type { IconCircleVariants } from './IconCircle'
import { IconCircle } from './IconCircle'

export type NavButtonProps = Omit<ComponentProps<'button'>, 'children'> &
	Pick<IconCircleVariants, 'intent' | 'theme'> & {
		state: NavState
		icon?: [IconPrefix, IconName]
		label?: string
		active: boolean
	}

export const NavButton: FC<NavButtonProps> = ({
	state,
	icon,
	label,
	active,
	intent,
	theme,
	className,
	...props
}) => {
	return (
		<button
			type="button"
			data-nav={state}
			className={cx(
				'group flex gap-x-md cursor-pointer items-center justify-center rounded-full outline-none pointer-events-auto h-11',
				theme === 'blue'
					? 'text-white'
					: 'text-blue hover:text-blue-shade-40 active:text-blue-shade-40',
				className,
			)}
			aria-expanded={active}
			aria-haspopup="menu"
			{...props}
		>
			{label && <span className="hidden text-h5 tablet-l:block">{label}</span>}
			{icon && (
				<IconCircle
					icon={active ? ['fas', 'times'] : icon}
					intent={active ? 'toggled' : intent}
					theme={theme}
					aria-hidden="true"
				/>
			)}
		</button>
	)
}
